import { useTranslation } from 'react-i18next'
import { useChatbotFlow } from '../chatbot.provider'
import { MEDIA_NOT_UPLOADED_HANDLE, MEDIA_UPLOADED_HANDLE } from '../chatbot.constants'
import { ConnectingNodeButton } from './connecting-node-button.component'
import { AddingNodeButton } from './adding-node-button.component'

type TChatbotNodeMediaResponseProps = {
  id: string
  showActions: boolean
  isRequired: boolean
}

type TMediaBranchProps = {
  id: string
  handleId: string
  label: string
  showActions: boolean
}

function MediaBranch({ id, handleId, label, showActions }: Readonly<TMediaBranchProps>) {
  const { addNodeWithConditionalConnection, edges } = useChatbotFlow()

  const hasEdge = edges.some((edge) => edge.source === id && edge.sourceHandle === handleId)
  const isEdgeSelected = edges.some(
    (edge) => edge.selected && edge.source === id && edge.sourceHandle === handleId,
  )

  const handleAddConditionalNode = (event: React.MouseEvent) => {
    event.stopPropagation()
    addNodeWithConditionalConnection(id, handleId)
  }

  return (
    <div className="c-flex-1 c-border c-border-grey-500 c-rounded c-p-3 c-relative c-h-auto c-pb-5">
      <div className="c-text-xs c-font-semibold c-text-center">{label}</div>
      <div className="c-absolute c-bottom-[-14px] c-left-0 c-right-0 c-flex c-justify-center c-gap-2">
        <ConnectingNodeButton
          handleId={handleId}
          isConnectable={!hasEdge}
          isConnected={hasEdge}
          isPartOfSelectedEdge={isEdgeSelected}
          showIcon={showActions}
        />
        {showActions && !hasEdge && <AddingNodeButton onClick={handleAddConditionalNode} />}
      </div>
    </div>
  )
}

export function ChatbotNodeMediaResponse({
  id,
  showActions,
  isRequired,
}: Readonly<TChatbotNodeMediaResponseProps>) {
  const { t } = useTranslation()

  return (
    <div className="c-flex c-flex-row c-gap-2 c-p-2 c-border-t c-border-gray-200">
      <MediaBranch
        id={id}
        handleId={MEDIA_UPLOADED_HANDLE}
        label={t('pages.configuration.followups.chatbot.node-editor.media-uploaded')}
        showActions={showActions}
      />
      {!isRequired && (
        <MediaBranch
          id={id}
          handleId={MEDIA_NOT_UPLOADED_HANDLE}
          label={t('pages.configuration.followups.chatbot.node-editor.media-not-uploaded')}
          showActions={showActions}
        />
      )}
    </div>
  )
}
